import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import UserView from "../shared/UserView"
import UserContext from "../../context/UserContext"
import SelectedCheckbox from "./SelectedCheckbox"

UserItem.propTypes = {
    item: PropTypes.object
}

function UserItem(props) {
    const {tenants} = useContext(UserContext)
    const {item, arrSelected, onSelected, onShowEdit} = props
    const tenantSelect = !!tenants && tenants.find(i => i.id === item.tenantId)

    return (
        <tr className="CustomersItem">
            <td>
                <SelectedCheckbox
                    id={item.userId}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                />
            </td>
            <td className="UserName">
                <UserView label={'Thông tin user'} item={item}/>
            </td>
            <td className="FullName">{item.fullName}</td>
            <td className="Dept">{!!tenantSelect ? tenantSelect.name : ''}</td>
            <td className="Dept">{item.deptName}</td>
            <td className="Status">{item.status === 1 ? 'Active' : 'Disable'}</td>
            <td className="calloutQueue">{item['extension'] || ''}</td>
            <td className="calloutQueue">{item.calloutQueue || ''}</td>
            <td className="calloutNumber">{item.calloutNumber || ''}</td>
            <td className="Actions">
                <div className="CustomerForm">
                    <span className="material-icons" onClick={() => onShowEdit(item)}>border_color</span>
                </div>
            </td>
        </tr>
    )
}

export default UserItem
